import React, { Component } from 'react'
import moment from 'moment-timezone'
import Datum from '../Datum'
import Node from './Node'
import { withStyles } from '@material-ui/core/styles'
import { DEFAULT_TIMEZONE } from '../../constants'

const styles = theme => ({
  root: {
    display: 'flex',
    position: 'relative'
  },
  subheader: {
    fontWeight: 'bold',
    marginTop: 5
  },
  content: {
    marginLeft: 15,
    paddingBottom: 40,
    width: '100%'
  },
  data: {
    display: 'flex',
    margin: '15px 0',
  },
  connector: {
    backgroundColor: 'silver',
    width: 3,
    position: 'absolute',
    left: 6,
    top: 15,
    bottom: 0
  },
  time: {
    margin: '0 5px',
    width: 85
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: '#e6e6e6'
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
})

class TimelineItem extends Component {
  getMeasurements (item) {
    const { id, name, notes, time, type, remedies, superType, text, end, active, ...measurements } = item
    if (Object.keys(measurements).filter(key => key.startsWith('duration_')).length > 0)  {
      const hours = measurements.duration_hours
      const minutes = measurements.duration_hours
      measurements.duration = `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`
      delete measurements.duration_hours
      delete measurements.duration_minutes
    }

    if ('dosage' in measurements && 'units' in measurements) {
      measurements.amount = `${measurements.dosage} ${measurements.units}`
      delete measurements.dosage
      delete measurements.units
    }

    if (type === 'weight') {
      measurements.amount = measurements.amount + ' kg'
    }

    return measurements
  }

  renderNotes (noteName) {
    const { classes } = this.props
    if (!this.props.info[noteName]) return null
    return (
      <div>
        <div className={classes.subheader}> {`${noteName}:`} </div>
        <div> { this.props.info[noteName] } </div>
      </div>
    )
  }

  render () {
    const { classes, info, last } = this.props
    return (
      <div className={classes.root}>
        <Node />
        <div className={classes.connector}/>
        <div className={classes.content}>
          <div className={classes.flex}>
            <div className={classes.time}>{moment.utc(info.time).tz(DEFAULT_TIMEZONE).format('h:mm a')}</div>
            <div className={classes.divider}/>
          </div>
          <div className={classes.data}>
            <Datum key={info.type} datum={{type: info.type, superType: info.superType, measurements: this.getMeasurements(info)}} size={30} withMeasurements fixWidth/>
          </div>
          { this.renderNotes('notes') }
          { this.renderNotes('remedies') }
        </div>
        { last && <Node last /> }
      </div>
    )
  }
}

export default withStyles(styles)(TimelineItem)



// WEBPACK FOOTER //
// ./src/components/Timeline/TimelineItem.js